export const API_UPDATE_USER_DISPLAY_NAME = '/api/v1/manage_user';
export const API_AUTH_VERIFY_OTP = '/api/v1/auth/verifyOtp';
export const API_AUTH_GENERATE_OTP = '/api/v1/auth/generateOtp';

export const API_CHECK_USER_EXIST = '/papi/v1/manage_user/existing/check';
export const API_SOCIAL_LOGIN = '/api/v1/auth/social/login';
export const API_SET_LOCATION = '';
export const GET_APP_CONFIG = '/api/config/all';
export const API_USER_UPDATE_PROFILE = '/api/manage_user/';

//---

export const API_USER_GET_PROFILE = '/api/auth/validateToken';
export const API_AUTH_VALIDATE_TOKEN = '/api/auth/validateToken';
export const API_AUTH_LOGOUT = '/api/auth/logout';
export const API_AUTH_LOGIN = '/api/auth/login';

export const API_AUTH_FORGOT_PWD = '/api/auth/forgotPassword/{username}';

export const API_AUTH_RESET_PWD = '/api/auth/resetPassword/{token}';

export const API_GET_ALL_STORES = '/api/store/all';
export const API_SEARCH_STORES = '/api/store/search/{pageNo}/{pageSize}';
export const API_GET_STORE_BY_ID = '/api/store/{storeId}';
export const API_GET_ALL_USERS = '/api/manage_user/all';
export const API_GET_SEARCH_USERS = '/api/manage_user/search';
export const API_POST_UPSERT_USER = '/api/manage_user/';
export const API_POST_DELETE_USER = '/api/manage_user/';
export const API_GET_USER_DETAILS = '/api/manage_user/detailsWithStores/{id}';
export const API_GET_USER_DETAILS_UUID = '/api/manage_user/detailsWithStoresByUuId/{uuId}';
export const API_POST_REMOVE_USER_STORES = '/api/manage_user/removeStore/{userId}/{storeId}';
export const API_POST_CHANGE_USER_PWD = '/api/manage_user/changeUserPassword/{id}';
// /store/{storeId}/{roleId}
export const API_GET_USERS_FOR_STORE = '/api/manage_user/store/';
export const API_GET_USER_STORES = '/api/manage_user/{userId}/stores/{pageNo}/{pageSize}';

export const API_POST_ASSIGN_USER_STORES = '/api/manage_user/assignStore/{userId}';

export const API_GET_ALL_USER_ROLES = '/api/role/all';

export const API_POST_UPSERT_STORE = '/api/store/';
export const API_GET_ALL_MONEY_ORDERS = '/api/moneyOrder/all';
export const API_GET_ALL_COUPONS = '/api/coupon/all';

export const API_GET_LOTTERY_CONFIG_BY_ID = '/api/lottery/id/{lotteryConfigId}';
export const API_GET_ALL_LOTTERY_CONFIGS = '/api/lottery/all';
export const API_GET_SEARCH_LOTTERY_CONFIG = '/api/lottery/search';
export const API_POST_UPSERT_LOTTERY_CONFIG = '/api/lottery/';
export const API_POST_DELETE_LOTTERY_CONFIG = '/api/lottery/';

export const API_GET_ALL_STORE_LOTTERY_CONFIGS = '/api/lottery/store/';
export const API_GET_SEARCH_STORE_LOTTERY_CONFIG = '/api/lottery/search/store';
export const API_POST_UPSERT_STORE_LOTTERY_CONFIG = '/api/lottery/storeLottery';
export const API_POST_DELETE_STORE_LOTTERY_CONFIG = '/api/lottery/storeLottery/';

export const API_POST_DOCUMENT = '/api/document/upload';
export const API_GET_SIGNED_DOCUMENT = '/api/document/presigned';
export const API_POST_SALES_DOCUMENT = '/api/salesAttachment/upload';
export const API_GET_SALES_ATTACHEMNTS = '/api/salesAttachment/{shiftId}/{version}/{type}';

export const API_GET_DAY_REPORT_SALES_ATTACHEMNTS = '/api/salesAttachment/dayReport/{reportId}/{type}';

export const API_GET_ALL_BRANDS = '/api/brand/all';
export const API_POST_UPSERT_BRAND = '/api/brand/';
export const API_POST_DELETE_BRAND = '/api/brand/';

//SHIFTS
export const API_GET_STORE_SHIFTS = '/api/shift/store/';
export const API_POST_UPSERT_SHIFT_CONFIG = '/api/shift/';
export const API_POST_DELETE_SHIFT_CONFIG = '/api/shift/{id}';
export const GET_APP_CONFIG_DAY_REPORT_FIELDS = '/api/config/dayReportFields';
export const GET_APP_CONFIG_ROYALTY = '/api/config/royalty';

//USER CONTEXT RELATED.
export const API_GET_USER_SHIFTS = '/api/shifts/{storeId}/{startDate}/{endDate}/{pageNo}/{pageSize}';
export const API_GET_USER_ONGOING_SHIFTS = '/api/user/ongoingShift/{storeId}/{startDate}/{endDate}/{pageNo}/{pageSize}';

export const API_GET_USER_DRAFT_SHIFT_REPORT = '/api/user/ongoingShiftReport/{shiftId}';

export const API_GET_USER_NON_APPROVAL_SHIFT_REPORT = '/api/user/incompleteShiftReports/{storeId}/{pageNo}/{pageSize}';

export const API_POST_CREATE_USER_SHIFT = '/api/user/startShift/{shiftConfigId}/{shiftDate}';
export const API_POST_END_USER_SHIFT = '/api/user/endShift/{shiftId}';

export const API_POST_USER_CHANGE_PWD = '/api/user/changePassword';

export const API_POST_UPSERT_CASH_ENTRY = '/api/sale/cashEntry';
export const API_POST_UPSERT_LOTTERY_SALES_ENTRY = '/api/sale/lottery';
export const API_POST_UPSERT_COUPON_SALES = '/api/sale/coupons';
export const API_POST_UPSERT_LOTTERY_LOSS = '/api/sale/lossLottery';
export const API_POST_UPSERT_LOTTERY_SALES = '/api/sale/lottery';
export const API_POST_UPSERT_MO_SALES = '/api/sale/moneyOrder';
export const API_POST_UPSERT_LOTTERY_PO = '/api/sale/lotteryPaidOut';
export const API_POST_UPSERT_MISC_PO = '/api/sale/miscPaidOut';
export const API_POST_UPSERT_VOID_SALES = '/api/sale/void';
export const API_POST_UPSERT_DROPS = '/api/sale/drops';

export const API_GET_CASH_ENTRY = '/api/sale/cashEntry/{shiftId}/{version}';
export const API_GET_LOTTERY_SALES_ENTRY = '/api/sale/lottery/{shiftId}/{version}/{pageNo}/{pageSize}';
export const API_GET_MO_SALES = '/api/sale/moneyOrder/{shiftId}/{version}/{pageNo}/{pageSize}';
export const API_GET_SALES_COUPON = '/api/sale/coupons/{shiftId}/{version}/{pageNo}/{pageSize}';
export const API_GET_LOTTERY_PO = '/api/sale/lotteryPaidOut/{shiftId}/{version}';
export const API_GET_MISC_PO = '/api/sale/miscPaidOut/{shiftId}/{version}/{pageNo}/{pageSize}';
export const API_GET_SALES_VOID_ENTRY = '/api/sale/void/{shiftId}/{version}';

export const API_GET_DROPS = '/api/sale/drops/{shiftId}/{version}/{pageNo}/{pageSize}';

export const API_POST_DELETE_MO_SALES = '/api/sale/moneyOrder/{id}';
export const API_POST_DELETE_LOTTERY_SALES = '/api/sale/lottery/{id}';
export const API_POST_DELETE_COUPON_SALES = '/api/sale/coupons/{id}';
export const API_POST_DELETE_MISC_PO_SALES = '/api/sale/miscPaidOut/{id}';
export const API_POST_DELETE_DROPS = '/api/sale/drops/{id}';

///api/shiftReports/all/1/2024-07-01/2024-07-18/1/100
export const API_GET_SHIFT_REPORTS = '/api/shiftReports/all/{storeId}/{startDate}/{endDate}/{pageNo}/{pageSize}';

export const API_GET_SHIFT_REPORT_REVIEWS = '/api/shiftReports/review/{reportId}';

export const API_POST_SHIFT_REPORT_REVIEW = '/api/shiftReports/review/{reportId}';

export const API_POST_APPROVE_SHIFT_REPORT = '/api/shiftReports/approve/{reportId}';

export const API_POST_SHIFT_REPORT_REOPEN = '/api/user/reopenShiftReport/{reportId}/{shiftId}';
export const API_POST_DAY_REPORT_REOPEN = '/api/user/reopenDayReport/{reportId}';

export const API_POST_DAY_REPORT_CHANGE_DATE = '/api/user/dayReport/{reportId}/changeDate/{newReportDate}';
export const API_POST_SHIFT_REPORT_CHANGE_DATE = '/api/user/shiftReport/{reportId}/changeDate/{newReportDate}';

export const API_DELETE_SHIFT_REPORT = '/api/user/shiftReport/{reportId}';
export const API_DELETE_DAY_REPORT = '/api/user/dayReport/{reportId}';

export const API_POST_UPSERT_MONEY_ORDER_CONFIG = '/api/moneyOrder/';
export const API_DELETE_MONEY_ORDER_CONFIG = '/api/moneyOrder/{id}';

export const API_GET_DAY_REPORTS = '/api/dayReports/all/{storeId}/{startDate}/{endDate}/{pageNo}/{pageSize}';

export const API_POST_UPSERT_DAY_REPORT = '/api/dayReports/{confirmed}';
export const API_POST_DELETE_DAY_REPORT = '/api/dayReports/{reportId}';
export const API_POST_SUBMIT_DAY_REPORT = '/api/dayReports/submit/{reportId}';
export const API_GET_DAY_REPORT_SUMMARY = '/api/dayReports/summary/{reportId}';

export const API_POST_DAY_REPORT_SALES_ENTRY = '/api/dayReports/salesEntry/{reportId}';

export const API_POST_DAY_REPORT_CASH_PO_ENTRY = '/api/dayReports/cashPOEntry/{reportId}';

export const API_POST_DAY_REPORT_CASH_DEPOSIT_ENTRY = '/api/dayReports/cashDepositEntry/{reportId}';

export const API_POST_DAY_REPORT_VOID_ENTRY = '/api/dayReports/voidsEntry/{reportId}';

export const API_GET_USER_DAY_REPORT_BY_STATUS = '/api/dayReports/{storeId}/{status}';

export const API_GET_DAY_REPORT_SALES_ENTRY = '/api/dayReports/salesEntry/{reportId}';

export const API_GET_DAY_REPORT_CASH_PO_ENTRY = '/api/dayReports/cashPOEntry/{reportId}';

export const API_GET_DAY_REPORT_CASH_DEPOSIT_ENTRY = '/api/dayReports/cashDepositEntry/{reportId}';

export const API_GET_DAY_REPORT_VOID_ENTRY = '/api/dayReports/voidsEntry/{reportId}';

export const API_GET_REPORT_UPLOAD_STATUS = '/api/exportReport/{id}';

export const API_DELETE_DAY_REPORT_VOID_ENTRY = '/api/dayReports/voidsEntry/{reportId}/{voidId}';

export const API_GET_TAXES_ALL = '/api/tax/all';

export const API_GET_TAXES_BY_ZIP = '/api/tax/zipcode/{zipcode}';

export const API_GET_TAXES_BY_STORE_ID = '/api/tax/store/{storeId}';
export const API_POST_UPSERT_TAX = '/api/tax/';
export const API_POST_DELATE_TAX = '/api/tax/{taxId}';

export const API_UPDATE_GAS_REPORT = '/api/gasReport/';

export const API_DELETE_GAS_REPORT = '/api/gasReport/{id}';

export const API_GET_GAS_REPORT_BY_ID = '/api/gasReport/{id}';
export const API_GET_GAS_REPORT_BY_DAY_REPORT_ID = '/api/gasReport/dayReport/{dayReportId}';

export const API_POST_APPROVE_DAY_REPORT = '/api/dayReports/approve/{reportId}';
export const API_GET_DAY_REPORT_REVIEWS = '/api/dayReports/review/{reportId}';
export const API_POST_DAY_REPORT_REVIEW = '/api/dayReports/review/{reportId}';

export const API_DOWNLOAD_REPORT_FILE = '/api/document/downloadFile/{docType}/{docId}';

export const API_POST_DASHBOARD_STATS = '/api/dashboard/summary/{storeId}';
export const API_POST_DASHBOARD_SALES_STATS = '/api/dashboard/dateWiseSales/{storeId}';
export const API_POST_DASHBOARD_GAS_SALES_STATS = '/api/dashboard/dateWiseGasSales/{storeId}';

export const API_POST_DASHBOARD_SALES_STATS_STORE_WISE = '/api/dashboard/storeWiseSales/{storeId}';
export const API_POST_DASHBOARD_GAS_SALES_STATS_STORE_WISE = '/api/dashboard/storeWiseGasSales/{storeId}';

export const API_POST_DASHBOARD_DAY_REPORT_COUNT_STATS = '/api/dashboard/dayReportStatusSummary/{storeId}';
export const API_GET_DASHBOARD_ACH_DAY_REPORT_STATUS_STORE_WISE =
  '/api/achReports/all/{storeId}/{startDate}/{endDate}/{pageNo}/{pageSize}';
export const API_GET_ACH_FORM_RESPONSES = '/api/achReports/formResponses/{reportId}';
export const API_GET_ACH_REPORT_DETAILS = '/api/achReports/details/{reportId}';
export const API_POST_APPROVE_ACH_REPORT = '/api/achReports/approve/{reportId}';
export const API_POST_UPDATE_ACH_FORM_DATA = '/api/achReports/updateForm/{formId}';
